import { PropTypes } from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";

import useDeviceDetect from "@hooks/useDeviceDetect";

import IconArrow from "@svgs/arrow-right.svg";
import SearchCard from "./SearchCard";

function SearchCards({ cards }) {
  const { isMobile } = useDeviceDetect();

  const swiperSettings = {
    navigation: {
      nextEl: ".search_cards__buttons_next",
      prevEl: ".search_cards__buttons_prev",
    },
    slidesPerView: 1,
  };

  if (isMobile) {
    return (
      <div className="mobile:mt-[35px]">
        {cards.map((card) => (
          <SearchCard card={card} key={card.title} />
        ))}
      </div>
    );
  }

  return (
    <div data-testid="search-cards">
      <div className="mb-[20px] flex gap-[20px] justify-end">
        <button type="button" className="search_cards__buttons_prev rotate-180">
          <IconArrow width="8" height="17" fill="none" stroke="#000000" />
        </button>
        <button type="button" className="search_cards__buttons_next">
          <IconArrow width="8" height="17" fill="none" stroke="#000000" />
        </button>
      </div>
      <Swiper navigation={swiperSettings.navigation} slidesPerView={swiperSettings.slidesPerView}>
        {cards.map((card) => (
          <SwiperSlide key={card.title}>
            <SearchCard card={card} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

SearchCards.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.any),
};

export default SearchCards;
